import React from "react";

interface ExplorerButtonProps {
  onClick: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary";
  children: React.ReactNode;
}

export const ExplorerButton: React.FC<ExplorerButtonProps> = ({
  onClick,
  disabled = false,
  variant = "primary",
  children,
}) => {
  return (
    <button
      className={`explorer-button ${variant}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

